import { style } from "@vanilla-extract/css";

export const shirt = style({
  display: "inline-block",
  margin: "auto",
  verticalAlign: "middle",
});
